import { types } from "../action-types";

const initialState = {
    loading: false,
    jobdetails:[],
    error: false,
};

const getJobDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_JOBDETAIL_REQUESTED:
            return {
                ...state,
                loading: true,
            };

        case types.GET_JOBDETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                jobdetails: action.payload,
                error: false,
            };
        case types.GET_JOBDETAIL_FAILURE:
            return {
                ...state,
                loading: false,
                jobdetails: [],
                error: true,
            };
        default:
            return state;
    }
};

export default getJobDetailReducer;
